<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-btn text small :to="{ name: 'RegistrationList' }">
          <v-icon left> mdi-arrow-left </v-icon>
          Back
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          outlined
          class="mx-2"
          @click="downloadLink(proforma)"
        >
          <v-icon left> mdi-download </v-icon>
          Download
        </v-btn>
        <v-btn color="primary" @click="pay">
          <v-icon left> mdi-send </v-icon>
          Pay KES
          {{ parseFloat(amountToPay.replace(/,/g, "")) | currencyFormat }}
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="8" offset="2">
            <v-card-text class="elevation-1 my-1">
              <pdf style="width: 100%" :src="proforma" />
            </v-card-text>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import FileMixin from "@brainspore/celadon-base/mixin/FileMixin";
import pdf from "vue-pdf";
import { AuthService } from "@/packages/dashboard/modules/auth";
export default {
  name: "RenewalProforma",
  components: { pdf },
  mixins: [FileMixin],
  data: function () {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.params.code) {
        v.$store.dispatch("Renewal/getRenewalProforma", to.params.code);
        window.document.title = "KISEB::Pay For Renewal";
      }
    });
  },
  computed: {
    renewal() {
      return this.$route.params.code
        ? this.$store.getters["Renewal/renewalGetters"]("renewals")
            .filter((el) => el.serviceRequest === this.$route.params.code)
            .shift()
        : [];
    },
    proforma() {
      return this.$store.getters["Renewal/renewalGetters"]("renewal_document");
    },
    user() {
      return AuthService.user;
    },
    amountToPay() {
      return this.$store.getters["Dashboard/amountToPay"];
    },
  },
  methods: {
    pay: function () {
      const PhoneNo =
        this.user.profile.phoneNo.charAt(0) === "+"
          ? this.user.profile.phoneNo.slice(1)
          : this.user.profile.phoneNo.charAt(0) === "0"
            ? `254${this.user.profile.phoneNo.slice(1)}`
            : this.user.profile.phoneNo;
      const data = this.renewal;
      this.$confirm.show({
        title: "Renewal Payment",
        rejectLabel: "Pay Later",
        text: `Application Payment for Renewal No. ${data.serviceRequest}`,
        onConfirm: () => {
          let payload = {
            payerID: data.profileID,
            sourceDocumentNo: data.serviceRequest,
            serviceID: data.serviceCode,
            description: "Renewal Payment",
            amount: parseFloat(this.amountToPay.replace(/,/g, "")).toString(),
            accountNo: PhoneNo,
            email: this.user.profile.email,
            idNumber: this.user.profile.identificationDocumentNo,
            name: `${this.user.profile.firstName} ${this.user.profile.lastName}`,
            success_url: `${process.env.VUE_APP_URL}${
              this.$router.resolve({ name: "RegistrationList" }).href
            }`,
            fail_url: window.location.href,
          };

          payload = btoa(JSON.stringify(payload));
          this.$checkout.pay(payload);
        },
        onCancel: () => {
          Event.$emit("ApiInfo", "Payment cancelled");
          this.$router.replace({ name: "RegistrationList" });
        },
      });
    },
  },
  watch: {
    proforma: function (val) {
      if (val) {
        this.$store.dispatch("Dashboard/getStudentAmountToPay", {
          profileNo: this.renewal.profileID,
          amount: this.renewal.billedAmount,
        });
      }
    },
  },
};
</script>

<style scoped></style>
